// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"TM-z","carouselContainer":"UM-z"};